import { useState } from 'react';
import { HX_SCENES } from './hx-scenes';

// The Home design's cover tile (`.cv`): the listing's photo over an illustrated scene, so
// a listing with no photo — or one whose photo fails to load — still shows a finished
// picture (never a blank box). The scene follows the category the way the design drew
// them: a table for food, a pitch for sport, a resort or a hotel block for stays.

/** A stable 0–1 seed from an id, to tell two hotel scenes apart. */
function seedOf(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h % 2;
}

export function hxSceneIndex(categoryId: string | undefined, id: string): number {
  switch (categoryId) {
    case 'restaurant':
    case 'event':
    case 'venue':
      return 0;
    case 'turf':
    case 'gym_fitness':
    case 'class':
      return 3;
    case 'hotel':
      return 1 + seedOf(id);
    default:
      return 2;
  }
}

export function Cover({ src, alt = '', categoryId, id, className }: { src?: string | undefined; alt?: string; categoryId?: string | undefined; id: string; className?: string }) {
  const [broken, setBroken] = useState(false);
  return (
    <div className={className ? `cv ${className}` : 'cv'}>
      {src && !broken ? <img src={src} alt={alt} loading="lazy" decoding="async" onError={() => setBroken(true)} /> : null}
      <svg
        viewBox="0 0 320 200"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: HX_SCENES[hxSceneIndex(categoryId, id)] ?? HX_SCENES[2] }}
      />
    </div>
  );
}
